import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import CarouselContentAnimate from 'components/CarouselContentAnimate';
import ArrowrightIcon from 'icons/Arrowright.icon';
import StarIcon from 'icons/Star.icon';

import './WhatsNextSection.styles.scss';
import './WhatsNextSection.styles.responsive.scss';

const whatsNextList = [
  { title: 'enquireViaListing' },
  {
    title: 'viewTeaser',
    className: 'view-teaser',
  },
  {
    title: 'reviewIM',
    className: 'review-im',
    buttonTextYes: 'signNDA',
    buttonTextNo: 'registerInterest',
    buttonIcon: <ArrowrightIcon />,
  },
  { title: 'submitNBIO*', className: 'next-steps' },
  { title: 'signHeadsAgreement', className: 'next-steps' },
  { title: 'signSaleAgreement', className: 'next-steps' },
  { title: 'settlement', icon: <StarIcon />, className: 'next-steps' },
];

type WhatsNextSectionProps = {
  className?: string;
  hasNda?: boolean;
  isDisabled?: boolean;
  onRegisterClick?: () => void;
};

const WhatsNextSection: FC<WhatsNextSectionProps> = ({
  className,
  hasNda,
  isDisabled,
  onRegisterClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames('white-panel', 'whats-next-section', className)}>
      <p>{t('whatsNext')}</p>

      <CarouselContentAnimate direction="none">
        <div className="whats-next-section__cards">
          {whatsNextList.map(
            ({
              title,
              icon,
              buttonIcon,
              buttonTextNo,
              buttonTextYes,
              className,
            }) => (
              <div
                key={title}
                className={classNames('whats-next-section__card', className)}
              >
                {icon}
                {t(title)}

                {buttonTextNo && onRegisterClick && (
                  <Button
                    icon={buttonIcon}
                    iconPosition="right"
                    disabled={isDisabled}
                    className={classNames({ noNDA: !hasNda })}
                    onClick={onRegisterClick}
                  >
                    {t(hasNda ? buttonTextYes : buttonTextNo)}
                  </Button>
                )}
              </div>
            ),
          )}
        </div>
      </CarouselContentAnimate>

      <span>
        <p>{t('informationMemorandum')}</p>
        <p>{t('nonBindingIndicativeOffer')}</p>
      </span>
    </div>
  );
};

export default WhatsNextSection;
